import { render, staticRenderFns } from "./ScrollingCardsView.vue?vue&type=template&id=590caa83&scoped=true&"
import script from "./ScrollingCardsView.vue?vue&type=script&lang=js&"
export * from "./ScrollingCardsView.vue?vue&type=script&lang=js&"
import style0 from "./ScrollingCardsView.vue?vue&type=style&index=0&id=590caa83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590caa83",
  null
  
)

export default component.exports